import {useQuery} from "@tanstack/react-query";
import {googleSpreadKeys} from "utils/constants/queryKeys/googleSpread";

export const useGetGoogleSpread = (sheetId, sheetName) => {
  const fetchRequest = (url, method, param, isNotRequiredAuth = false) => {
    const headers = {
      "Content-Type": "application/json; charset=utf-8",
    };

    if (localStorage.getItem("redbrickToken") && !isNotRequiredAuth) {
      headers.Authorization = `Bearer ${localStorage.getItem("redbrickToken")}`;
    }

    if (param) {
      return fetch(url, {
        method,
        headers,
        body: JSON.stringify(param),
      });
    }
    return fetch(url, {
      method,
      headers,
    });
  };

  return useQuery(
    googleSpreadKeys.spreadsheet({sheetId, sheetName}),
    async () => {
      const API_KEY = process.env.REACT_APP_GOOGLE_SPREAD_API_KEY;
      const url = `https://content-sheets.googleapis.com/v4/spreadsheets/${sheetId}/values/${sheetName}?key=${API_KEY}`;
      const res = await fetchRequest(url, "GET", null, true);
      const data = await res.json();
      return data;
    },
    {
      staleTime: Infinity,
      select: response => {
        const keys = response.values[0];
        const data = response.values.slice(1);
        return data.map(arr =>
          Object.assign(
            {},
            ...keys.map((k, i) => {
              if (!k) return null;
              return {[k]: arr[i]};
            }),
          ),
        );
      },
    },
  );
};
